import { Button, Modal } from "react-bootstrap"
import React, { useState } from "react"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Select from "react-select"
import Icon from "../../common/icon/icon.component"
import ReminderService from "../../state/reminder/ReminderService"
import Reminder from "../../state/reminder/Reminder"
import { isError } from "../../state/helpers/Error"
import RichTextEditor from "../../common/rich-text/editor.component.jsx"
import EmailSelectionComponent from "../../common/email/emailselection.component.jsx"
import IntlProps from "../../state/helpers/IntlProps"

type OwnProps = {
    reminder?: Reminder,
    onHide: () => void,
    onRefresh: () => void,
}

const messages = defineMessages({
    "period": {
        id: "reminder.period_label",
        defaultMessage: "before",
    },
    "subject": {
        id: "reminder.subject_label",
        defaultMessage: "Unpaid Invoice",
    },
    "content": {
        id: "reminder.content_label",
        defaultMessage: "Hello, you currently have an unpaid invoice.",
    },
    "buttonLabel": {
        id: "reminder.buttonLabel_label",
        defaultMessage: "Open Invoice",
    },
    "errorMessage": {
        id: "reminder.error.numberOfDays",
        defaultMessage: "Please enter a day between 1 and 30",
    }
})

const ReminderModal = (props: OwnProps & IntlProps) => {

    const fullName = AppContext.getUserLoggedIn().attributes.firstName + " " + AppContext.getUserLoggedIn().attributes.lastName
        || ""
    const email = AppContext.getUserLoggedIn().attributes.email || ""
    const locationId = AppContext.getUserLoggedIn().attributes?.location?.id || ""

    const [period, setPeriod] = useState(props.reminder ? props.reminder.getPeriod() :
        props.intl.formatMessage(messages["period"]))
    const [numberOfDays, setNumberOfDays] = useState(props.reminder ? props.reminder.getNumberOfDays() : 1)
    const [subject, setSubject] = useState(props.reminder ? props.reminder.getSubject() :
        props.intl.formatMessage(messages["subject"]))
    const [fromName, setFromName] = useState(props.reminder ?
        props.reminder.getFromName() : fullName)
    const [fromEmail, setFromEmail] = useState(props.reminder ?
        props.reminder.getFromEmail() : email)
    const [content, setContent] = useState(props.reminder ?
        props.reminder.getContent() : props.intl.formatMessage(messages["content"]))
    const [buttonLabel, setButtonLabel] = useState(props.reminder ?
        props.reminder.getButtonLabel() : props.intl.formatMessage(messages["buttonLabel"]))
    const [pdfIncluded, setPdfIncluded] = useState(props.reminder ?
        props.reminder.getIncludeAttatchment() : false)
    const [errorMessage, setErrorMessage] = useState("")


    const options = [
        { value: "before", label: "before" },
        { value: "after", label: "after" }
    ]

    const createReminder = async () => {
        ReminderService.CreateReminder(period,
            numberOfDays,
            subject,
            fromName,
            fromEmail,
            content,
            buttonLabel,
            pdfIncluded).then(res => {
            if (!isError(res)) {
                props.onHide()
                props.onRefresh()
            } else {
                setErrorMessage(res.message)
            }
        })
    }

    const deleteReminder = async () => {
        const reminderId = props.reminder ? props.reminder.getId() : ""
        ReminderService.DeleteReminder(reminderId).then(res => {
            if (!isError(res)) {
                props.onHide()
                props.onRefresh()
            } else {
                setErrorMessage(res.message)
            }
        })
    }

    const updateReminder = async () => {
        const reminderId = props.reminder ? props.reminder.getId() : ""
        ReminderService.UpdateReminder(
            reminderId,
            period,
            numberOfDays,
            subject,
            fromName,
            fromEmail,
            content,
            buttonLabel,
            pdfIncluded).then(res => {
            if (!isError(res)) {
                props.onHide()
                props.onRefresh()
            } else {
                setErrorMessage(res.message)
            }
        })
    }

    const checkNumberOfDays = (numberOfDays) => {
        if (numberOfDays < 31 && numberOfDays > 0) {
            return true
        } else {
            return false
        }
    }

    return (
        <Modal
            onHide={props.onHide}
            show={true}
            scrollable={true}
            size={"lg"}
            centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage
                        id="reminders.modal_title_label"
                        defaultMessage="{reminder} Reminder"
                        values={{
                            reminder: props.reminder ?
                                <FormattedMessage id="reminders.updated_label" defaultMessage="Update" /> :
                                <FormattedMessage id="reminders.created_label" defaultMessage="Create" />
                        }}
                    />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid" style={{ minHeight: "400px", minWidth: "100px" }}>
                <div className="col-12 ui-module">
                    <div className="container-fluid">
                        <div className="form-group row mb-1">
                            <div className="col-md-7" style={{ padding: "10px" }}>
                                <FormattedMessage
                                    id="reminders.reminder_label"
                                    defaultMessage="Send email reminder for unpaid invoices"
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-1">
                            <div className="col-md-7" style={{ padding: "10px" }}>
                                <FormattedMessage
                                    id="reminders.modal_days_label"
                                    defaultMessage="{numberOfDays} days {period} the due date."
                                    values={{
                                        numberOfDays: (
                                            <input
                                                type="number"
                                                step="1"
                                                min="1"
                                                max="30"
                                                value={numberOfDays}
                                                onChange={
                                                    async (numberOfDays) => {
                                                        if (checkNumberOfDays(numberOfDays.target.value)) {
                                                            setErrorMessage("")
                                                            setNumberOfDays(parseInt(numberOfDays.target.value))
                                                        } else {
                                                            setErrorMessage(props.intl.formatMessage(messages["errorMessage"]))

                                                        }
                                                    }
                                                }
                                            />
                                        ),
                                        period: (
                                            <div style={{ width: "140px", display: "inline-block", height: "20px" }}>
                                                <Select
                                                    classNamePrefix="react-select"
                                                    isSearchable={false}
                                                    clearable={false}
                                                    menuPlacement="bottom"
                                                    options={options}
                                                    value={period}
                                                    onChange={(value) => {
                                                        setPeriod(value.value)
                                                    }}
                                                />
                                            </div>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 ui-module">
                    <div className="container-fluid">
                        <div className="form-group row mb-1">
                            <label className="col-3 pb-2">
                                <FormattedMessage
                                    id="reminder_email.modal.title_label"
                                    defaultMessage="Configure Email"
                                />
                            </label>
                        </div>
                        <div className="form-group row mb-1">
                            <label className="col-2 col-form-label custom-form-label pb-2">
                                <FormattedMessage
                                    id="reminder_email.modal.subject_label"
                                    defaultMessage="Subject"
                                />
                            </label>
                            <div className="col-10">
                                <input
                                    name="subject"
                                    value={subject}
                                    onChange={(subject) => {
                                        setSubject(subject.target.value)
                                    }
                                    }
                                    id="subject"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-1">
                            <label className="col-2 col-form-label custom-form-label pb-2"
                                htmlFor="fromName">
                                <FormattedMessage
                                    id="reminder_email.modal.from_name_label"
                                    defaultMessage="From Name"
                                />
                            </label>
                            <div className="col-10">
                                <input
                                    name="fromName"
                                    value={fromName}
                                    onChange={(fromName) => {
                                        setFromName(fromName.target.value)
                                    }}
                                    id="fromName"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-1">
                            <label className="col-2 col-form-label custom-form-label pb-2"
                                htmlFor="fromEmail">
                                <FormattedMessage
                                    id="reminder_email.modal.from_label"
                                    defaultMessage="From"
                                />
                            </label>
                            <div className="col-10">
                                <EmailSelectionComponent
                                    fromEmail={fromEmail ? [fromEmail] : []}
                                    locationId={locationId}
                                    templateKey="send-invoice"
                                    onChange={(fromEmail) => {
                                        setFromEmail(
                                            fromEmail.length > 0 ? fromEmail[0] : ""
                                        )
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-0">
                            <label className="col-12 col-form-label custom-form-label pb-2">
                                <FormattedMessage
                                    id="reminder_email.modal.content_label"
                                    defaultMessage="Content"
                                />
                            </label>
                            <div className="col-12">
                                <RichTextEditor
                                    height={300}
                                    name="content"
                                    value={content}
                                    onChange={(content) => {
                                        setContent(content)
                                    }}
                                    id="content"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-0 d-flex">
                            <label className="col-form-label custom-form-label pb-2 px-3 "
                                htmlFor="ccEmail">
                                <FormattedMessage
                                    id="reminder_email.modal.button_label"
                                    defaultMessage="Button label"
                                />
                            </label>
                            <div className="ml-2 flex-fill pr-3">
                                <input
                                    name="buttonLabel"
                                    value={buttonLabel}
                                    onChange={(buttonLabel) => {
                                        setButtonLabel(buttonLabel.target.value)
                                    }}
                                    id="buttonLabel"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className={"mb-1 form-group row mt-3"}>
                            <div className="col-12">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="pdfIncluded"
                                        name="pdfIncluded"
                                        checked={pdfIncluded}
                                        onChange={(pdfIncluded) => {
                                            setPdfIncluded(pdfIncluded.target.checked)
                                        }}
                                    />
                                    <label className="custom-control-label" htmlFor="pdfIncluded">
                                        <FormattedMessage
                                            id="reminder_email.modal.include_pdf_attachment"
                                            defaultMessage="Include Pdf attachment"
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="mr-auto p-2">
                    <div style={{ color: "red" }}>{errorMessage}</div>
                    {props.reminder &&
                        <span className={"text-danger"}>
                            <Button
                                onClick={() => {
                                    deleteReminder()
                                }}
                                variant="danger">
                                <Icon value={"trash"} className={"mr-2"} />
                                <FormattedMessage
                                    id="reminders.modal_delete_label"
                                    defaultMessage="Delete"
                                />
                            </Button>
                        </span>}
                </div>
                <div className="p-2">
                    <Button
                        variant="primary"
                        disabled={!fromEmail}
                        onClick={() => {
                            setErrorMessage("")
                            if (props.reminder) {
                                updateReminder()
                            } else {
                                createReminder()
                            }
                        }}>
                        <FormattedMessage
                            id="reminders.modal_confirm_label"
                            defaultMessage="Confirm"
                        />
                    </Button>
                </div>
            </Modal.Footer>
        </Modal >

    )

}

export default injectIntl(ReminderModal)


// WEBPACK FOOTER //
// ./src/reminder/modals/ReminderModal.tsx